<template>
  <p
    :class="[
      'editorParagraph',
      `editorParagraph--${data.alignment}`,
      { 'editorParagraph--small': small },
    ]"
    v-html="parseTags"
  />
</template>

<script>
export default {
  name: 'EditorParagraph',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    parseTags() {
      let parsedText = this.data.text;
      parsedText = parsedText.replace(/<b>/g, '<strong>');
      return parsedText.replace(/<\/b>/g, '</strong>');
    },
  },
};
</script>

<style lang="scss">
.editorParagraph {
  font-size: 1.8rem;
  line-height: 2.6rem;
  color: $cAddDark02;

  @include rwd('tablet') {
    font-size: 1.6rem;
    line-height: 2.4rem;
  }

  strong {
    font-weight: 700;
  }

  i {
    font-style: italic;
  }

  a {
    color: $cSec;
    transition: opacity $tr;

    &:hover {
      opacity: 0.6;
    }
  }

  &--center {
    text-align: center;
  }

  &--right {
    text-align: right;
  }

  &--left {
    text-align: left;
  }

  &--small {
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: $cAddDark02;

    @include rwd('tablet') {
      font-size: 1.4rem;
      line-height: 2.2rem;
    }
  }
}
</style>
